export default {
  signIn: 'Connexion',
  signUp: 'Démarrer maintenant',
  getStarted: 'Commencer',
};
